export enum PriceSizeEnum {
  "S" = 5,
  "M" = 4,
  "L" = 3,
}
